import React from "react";

import {
  DataTableBody,
  DataTableHead,
  DataTableRow,
} from "../../components/Component";
import PartnersPageTableBodyItem from "./PartnersPageTableBodyItem";

import { usePartnerPageContext } from "../../hooks/usePartnerPageContext";

const PartnersPageTableBody = () => {
  const { partners } = usePartnerPageContext();

  return (
    <DataTableBody>
      <DataTableHead>
        <DataTableRow text="Order" />
        <DataTableRow text="Logo" />
        <DataTableRow text="Name" />
        <DataTableRow text="Category" />
        <DataTableRow text="Created Date" />
        <DataTableRow text="Home Slider" />
        <DataTableRow text="Active" />
        <DataTableRow className="nk-tb-col-tools" noText />
      </DataTableHead>
      {partners?.map((item) => (
        <PartnersPageTableBodyItem key={item?.id} item={item} />
      ))}
    </DataTableBody>
  );
};

export default PartnersPageTableBody;
